import React, { useState, useContext, useReducer, useEffect } from "react";
import { cleanJoin } from "../../../../../utils/stringUtil";
import { back } from "../PreviewDocumentsUtils";
import { Row } from "../../../../../common/columns";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../common/modal/Modal";
import { MessageContext } from "../../../../../common/message/MessageContext";
import { reducer } from "../RequestPreviewDocumentsPageReducer";
import { UserContext } from "../../../../../common/user/UserContext";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";

function DocumentAcceptanceActions({
  stated,
  disabled,
  doc,
  documentSendBack,
  documentSubmit,
  documentRemove,
  setSelected,
  setIsBlocking,
}) {
  const [state, dispatch] = useReducer(reducer, stated);

  const { t } = useTranslation();
  const [signUrl, setSignUrl] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [visibleSignature, setVisibleSignature] = useState(false);
  const message = useContext(MessageContext);
  const [isModalActive, setIsModalActive] = useState(null);
  const [signInProgress, setSignInProgress] = useState(false);

  const user = useContext(UserContext);

  const [newHref, setNewHref] = useState("");

  const upload = async (signature, nameSurname, oib) => {
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${doc.href}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => {
        if (response.ok) {
          return response.arrayBuffer();
        } else throw new Error("Greška: Dohvat dokumenta nije uspio.");
      })
      .then((file) => {
        let uInt8Array = new Uint8Array(file);

        let blob = new Blob([uInt8Array]);
        let form = new FormData();
        form.append("files", blob, doc.label + ".pdf");
        if (signature === "true") {
          form.append("VisibleSignature", signature);
          form.append("NameSurname", nameSurname);
          form.append("oib", oib);
        }

        setSignInProgress(true);

        fetch("https://epotpis-test.dokumentit.hr/potpisi", {
          method: "POST",
          headers: {
            "X-Api-Key": "secrethkms",
          },
          body: form,
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else
              throw new Error(
                "Greška: Došlo je do greške prilikom pokušaja potpisivanje dokumenta."
              );
          })
          .catch((error) => {
            setSignInProgress(false);
            console.log("Error", error);
          })
          .then((result) => {
            setSignUrl(result.signUrl);
            setVerificationCode(result.files[0].verificationCode);
          })
          .finally(setIsModalActive(true));
      });
  };

  const uploadSigned = function () {
    let headers = new Headers();
    headers.append("X-Api-key", "secrethkms");

    let requestOpts = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    fetch(
      `https://epotpis-test.dokumentit.hr/dohvatiPotpisaniDokument/${verificationCode}.pdf`,
      requestOpts
    )
      .then((response) => {
        if (response.ok) {
          return response.arrayBuffer();
        } else
          throw new Error(
            "Greška: Dohvat potpisanog dokumenta nije uspio ili je korisnik prekinuo potpisivanje."
          );
      })
      .then((result) => {
        let headers = new Headers();
        headers.append("Request-Origin", "pisarnica");
        let uInt8Array = new Uint8Array(result);

        let blob = new Blob([uInt8Array]);
        let form = new FormData();
        form.append("File", blob, doc.label + ".pdf");
        form.append("Id", stated.request.uid);

        let requestOptions = {
          method: "POST",
          headers: headers,
          body: form,
          redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_GATEWAY_URL}/upload`, requestOptions)
          .then((response) => {
            if (response.ok) {
              return response.text();
            } else throw new Error("Došlo je do pogreške prilikom potpisivanja dokumenta.");
          })
          .then((result) => {
            dispatch({
              type: "setVerificationCode",
              payload: { doc: doc, href: result.substring(9, result.length - 2) },
            });
            setNewHref(result.substring(9, result.length - 2));
          })
          .catch((error) => {
            console.log("error", error);
          });
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (!isModalActive && signInProgress) {
      uploadSigned();
      setSignInProgress(false);
    }
  }, [isModalActive]);

  //&& doc.uploadProgress === 100 -> Ako se vrati, krivi prikaz btn na starim, vec upl. pdf
  if (doc.uploadStatus === 4) {
    return (
      <>
        <Modal
          isActive={isModalActive}
          setIsActive={setIsModalActive}
          render={() =>
            signUrl && (
              <iframe
                id={"signature-iframe"}
                className={"is-centered"}
                style={{
                  overflow: "none",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                }}
                width={850}
                height={600}
                title="sdurdd"
                src={signUrl}
              ></iframe>
            )
          }
        />
        <Row className="buttons is-centered is-grouped">
          <button
            onClick={() => {
              documentRemove(doc);
            }}
            className={cleanJoin(
              "button",
              "document-acceptance-button",
              "no-focus-outline",
              "has-border-red-1",
              doc.color !== "red"
                ? "has-background-danger-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                : ""
            )}
          >
            {t("requests.decisionAcceptance.action.remove")}
          </button>
          {disabled === false ? (
            <>
              <button
                id="sendBack"
                className={cleanJoin(
                  "button",
                  "document-acceptance-button",
                  "no-focus-outline",
                  "has-border-yellow-1",
                  "has-background-warning-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                )}
                disabled={doc.color === "red" ? true : false}
                onClick={() => back(setSelected, setIsBlocking, disabled)}
              >
                {t("requests.documentAcceptance.action.returnBack")}
              </button>
              <button
                id="submit"
                disabled={doc.color === "green" ? true : false}
                className={cleanJoin(
                  "button",
                  "document-acceptance-button",
                  "no-focus-outline",
                  "has-border-green-1",
                  doc.color !== "green"
                    ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                    : ""
                )}
                onClick={() => {
                  message.toggle({
                    show: true,
                    title: "Potpisivanje dokumenta",
                    content: "Želite li vidljivi potpis na vašem dokumentu?",
                    yesLabel: "Da",
                    noLabel: "Ne",

                    onX: () => {
                      message.toggle({ show: false });
                    },

                    onYes: async () => {
                      setVisibleSignature(true);
                      await upload("true", user.signUser.nameSurname, user.signUser.oib);
                      message.toggle({ show: false });
                    },
                    onNo: async () => {
                      setVisibleSignature(false);
                      await upload("false", user.signUser.nameSurname, user.signUser.oib);
                      message.toggle({ show: false });
                    },
                  });
                }}
              >
                {t("requests.decisionAcceptance.action.sign")}
              </button>
              <button
                id="submit" //POMJENITI NA DIGITALNO PEČATIRAJ
                disabled={doc.color === "green" ? true : false}
                className={cleanJoin(
                  "button",
                  "document-acceptance-button",
                  "no-focus-outline",
                  "has-border-green-1",
                  doc.color !== "green"
                    ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                    : ""
                )}
                onClick={() => {
                  //documentSubmit(doc); // DORADA
                }}
              >
                {t("requests.decisionAcceptance.action.stamp")}
              </button>
            </>
          ) : (
            ""
          )}
        </Row>
      </>
    );
  } else {
    return (
      <Row className="buttons is-centered is-grouped">
        <button
          onClick={() => back(setSelected, setIsBlocking, disabled)}
          className={cleanJoin(
            "button",
            "document-acceptance-button",
            "no-focus-outline",
            "has-border-yellow-1",
            "has-background-warning-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          )}
        >
          {t("requests.documentAcceptance.action.back")}
        </button>
        {disabled === false ? (
          <>
            <button
              id="sendBack"
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "no-focus-outline",
                "has-border-red-1",
                doc.color !== "red"
                  ? "has-background-danger-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                  : ""
              )}
              disabled={doc.color === "red" ? true : false}
              onClick={() => documentSendBack(doc)}
            >
              {t("requests.documentAcceptance.action.sendBack")}
            </button>
            <button
              id="submit"
              disabled={doc.color === "green" ? true : false}
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "no-focus-outline",
                "has-border-green-1",
                doc.color !== "green"
                  ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                  : ""
              )}
              onClick={() => documentSubmit(doc)}
            >
              {t("requests.documentAcceptance.action.accept")}
            </button>
          </>
        ) : (
          ""
        )}
      </Row>
    );
  }
}

export default DocumentAcceptanceActions;
